import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider , darkTheme} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from './wagmi';
import { ThemeProvider } from 'styled-components';

const theme = {
  colors: {
    primary: '#4ad0ac',
    secondary: '#2a2a3a',
    dark: '#1a1a2a',
    light: '#ffffff'
  },
  fonts: {
    pixel: "'Press Start 2P', 'Courier New', monospace"
  },
  boxShadows: {
    neon: '0 0 10px #4ad0ac, 0 0 20px rgba(74, 208, 172, 0.5)'
  }
};

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
        <RainbowKitProvider  theme={darkTheme({
          accentColor: '#4ad0ac',
          accentColorForeground: 'white',
          borderRadius: 'medium',
        })}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
reportWebVitals();
